import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    // if(this.$store.getters.userInfo == null){
      store.dispatch('getUserInfo').then(res=>{
      })
    // }
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      let param = to.path
      if (to.path != '/dashboard') {
        store.dispatch("checkHasPath", param).then(res => {
          if (!res) {
            if(to.path != '/workbench'){
              Message.error('您没有权限访问目标页面')
            }
            NProgress.done()
            next({path: '/dashboard'})
            return
          }
          store.dispatch('getMenus').then(res => {
            next()
          }).catch((e) => {
            console.log(e);
            store.dispatch('logOut').then(() => {
              Message.error('验证失败,请重新登录')
              next({ path: '/login' })
            })
          })
        })
      } else {
        store.dispatch('getMenus').then(res => {
          next()
        }).catch((e) => {
          console.log(e);
          store.dispatch('logOut').then(() => {
            Message.error('验证失败,请重新登录')
            next({ path: '/login' })
          })
        })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
